// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Delete = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      d="M14.5 4.5h-11M7.5 7.5v4M10.5 7.5v4"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 4.5v8a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-8M11.5 4.5v-1a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1"
    />
  </svg>
);
const ForwardRef = forwardRef(Delete);
export default ForwardRef;
